<template>
	<div class="receipts-panel column separated">
		<table class="receipts-table list-group">
			<tr class="receipts-table-header">
				<th class="receipt-date">Date</th>
				<th class="receipt-amount">Amount</th>
				<th class="receipt-payment">Payment</th>
			</tr>
			<tr class="receipts-table-spacer"></tr>
			<tr-placeholder v-if="receipts.list.length === 0 && status.loading"></tr-placeholder>
			<tr v-else v-for="(receipt, index) in receipts.list" :key="index" class="list-item" :class="{overdue:receipt.overdue}">
				<td class="receipt-date"><router-link :to="{ path: '/receipt/' + (receipt.id || receipt.chargeId)}"><time>{{ receipt.createdDate | date('medium') }}</time></router-link></td>
				<td class="receipt-amount">{{ receipt.amount | currency }}</td>
				<td class="receipt-payment">
					<span v-if="receipt.cardBrand === 'amex'" class="card-hint">
						<i class="fab fa-cc-amex"></i>
						<span class="card-digits">{{ receipt.cardLast4 }}</span>
					</span>
					<span v-else class="card-hint">
						<i class="fab" :class="getCardClass(receipt.cardBrand)"></i>
						<span class="card-digits">{{ receipt.cardLast4 }}</span>
					</span>
					<i class="receipt-overdue fa fa-exclamation"></i>
				</td>
			</tr>
		</table>

		<div class="list-group">
			<div class="empty list-item column centering" v-if="receipts.list.length === 0 && status.success">
				<div class="circle">
					<i class="fa fa-receipt jumbo"></i>
				</div>
				<h3>No past payments</h3>
			</div>
		</div>

		<div class="row rigid actions" v-if="receipts.hasMore" >
			<button class="link" @click="receipts.more">
				Show More
			</button>
		</div>
	</div>

</template>

<script>
import Vue from 'vue';
import date from '../filters/date.js';
import currency from '../filters/currency.js';
import TrPlaceholder from './TrPlaceholder.vue';

export default {
	name: 'TheReceiptTable',
	props: {
		list: Array,
		status: Object
	},
	components: {
		TrPlaceholder
	},
	data() {
		return {
			cap: 5,
			pageSize: 10
		};
	},
	filters: {
		date,
		currency
	},
	computed: {
		receipts() {
			return this.createPage(this.list, this.pageSize, this.cap);
		}
	},
	methods: {
		getCardClass(cardBrand) {
			if (!cardBrand) {
				return;
			}
			return 'fa-cc-' + cardBrand.toLowerCase();
		},
		createPage(list, pageSize, initialSize) {
			if (!isFinite(pageSize)) {
				pageSize = 10;
			}
			const vm = this;
			var cap = isFinite(initialSize) ? initialSize : pageSize,
				view = {
					list: list.slice(0, cap),
					hasMore: (list.length > cap),
					more: function showMore() {
						cap += pageSize;
						view.list = list.slice(0, cap);
						view.hasMore = (list.length > cap);
						vm.$forceUpdate();

					},
				};
			return view;
		},
	}
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

	.actions.row {
		height: 30px;
	}

	.actions .link {
		margin: auto;
	}

	.receipt-amount {
		text-align: left;
	}

	.receipt-overdue {
		display: none;
	}

	.list-item.empty {
		padding: 3rem;
	}

	.list-item.empty h3:last-child{
		margin-bottom: 0;
	}


	.empty .circle {
		background: #EBF6FF;
	    height: 100px;
	    width: 100px;
	    border-radius: 50%;
	    overflow: hidden;
		position: relative;
	}


	.dark .empty .circle {
		background: #243044;
	}

	.empty .circle > i {
		position: absolute;
		top: 40px;
		left: 0;
		right: 0;
		color: #7CB9EE;
		bottom: 0;
		font-size: 5rem;
		text-align: center;
		/* transform: rotate(25deg);*/
	}

	td:nth-child(3) {
		width: 100px;
	}
</style>



// WEBPACK FOOTER //
// ./src/components/TheReceiptTable.vue